<template>
    <div class="phone-shadow mask" v-if="show" @click="close">
        <div class="phone-model" @click.stop>
            <div class="phone-model-title">绑定手机</div>
            <div class="phone-model-det gray-light">确保能顺利使用本系统，请先进行手机绑定，</div>
            <div class="phone-model-from">
                <span class="gray phone-front">+86</span>
                <van-cell-group>
                    <van-field maxlength='11' v-model="formData.phone" placeholder="请输入手机号"/>
                </van-cell-group>
            </div>
            <div class="phone-model-from phone-model-yz">
                <van-cell-group>
                    <van-field maxlength="6" v-model="formData.code" placeholder="请输入验证码"/>
                </van-cell-group>
                <!--                <span class="phone-model-inter">(34s)</span>-->
                <div :class='clockSecond>0 ?"phone-model-inter":"get-code"' @click="getCode">{{clockSecond>0?
                    '('+clockSecond+'s)':'获取验证码'}}
                </div>
            </div>
            <van-button type="info" @click.stop="bindPhone" class="phone-submit-btn">立即绑定</van-button>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {
        Toast
    } from 'vant';

    Vue.use(Toast);
    export default {
        name: "LoginDialog",
        props: {
            show: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                formData: {
                    phone: '',
                    code: '',
                    openid: ''
                },

                clockSecond: 0,
            }
        },
        watch: {
            show(newVal, oldVal) {
                let that = this;
                console.log('--------login show----------');
                // 跳转登陆页面
                that.$router.replace({
                  name: 'Login'
                })
                if (newVal) {
                    console.log('--------获取openid----------');
                    this.$api.get('/api/index/getAuthType', {}, res => {
                        console.log(res);
                        if (res.data.type == 'login_success') {
                            that.$emit('loginSuccess', res.data.data);//登录成功
                        } else if (res.data.type == 'weixin_oauth') {
                            localStorage.removeItem('_bind_phone');
                            localStorage.removeItem('_openid');
                            location.replace(res.data.url + '?target_url=' + encodeURIComponent(document.URL) + '&user_mark=' + localStorage.getItem('_user_mark') + '&wx_entry_url=' + encodeURIComponent(sessionStorage.getItem("wx_entry_url")));
                        } else if (res.data.type = 'phone_bind') {
                            that.formData.openid = res.data.openid;
                            that.formData.name = res.data.nickname;
                            that.formData.face = res.data.face;
                        }
                    });
                }
            }
        },
        methods: {
            bindPhone() {
                let that = this;
                if(!that.formData.code) {
                    Toast('请输入验证码')
                    return;
                }
                that.formData.wx_entry_url = sessionStorage.getItem('wx_entry_url');
                that.formData._seller_id = localStorage.getItem('_seller_id');
                that.formData._user_mark = localStorage.getItem('_user_mark');
                that.$api.post('/api/weixin/bindPhone', that.formData, res => {
                    console.log(res);
                    localStorage.removeItem('_bind_phone');
                    localStorage.removeItem('_openid');
                    localStorage.setItem('_token', res.data.token);
                    that.$emit('loginSuccess', res.data);//登录成功
                })
            },
            close() {
                this.$emit('loginCancel', {});//取消
            },

            getCode() {
                let that = this;
                if (that.clockSecond > 0) {
                    return;
                }
                if (!that.formData.phone) {
                    Toast('请输入手机号')
                    return;
                }
                /*if (!that.formData.code) {
                    Toast('请输入验证码')
                    return;
                }*/
                that.$api.get('/api/index/phonecode', {phone: that.formData.phone}, (res) => {
                    Toast(res.msg);
                })

                that.clockSecond = 60;

                var t = setInterval(function () {
                    if (that.clockSecond > 0) {
                        that.clockSecond = that.clockSecond - 1;
                    } else {
                        clearInterval(t);
                    }
                }, 1000)
            }
        }
    }
</script>

<style scoped>

    .phone-shadow {
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2000;
    }

    .phone-model {
        width: 6.2rem;
        background: rgba(255, 255, 255, 1);
        border-radius: 0.1rem;
        background: #fff url(../assets/newImg/bg-phone-bind.png) no-repeat;
        background-size: 100% 80%;
        padding: 0.4rem 0.3rem 0.6rem;
        box-sizing: border-box;
    }

    .phone-model-title {
        color: #333333;
        font-size: 23px;
        font-weight: 500;
    }

    .phone-model-det {
        font-size: 12px;
        margin-top: 0.2rem;
    }

    .phone-model-from {
        height: 0.9rem;
        background: #F4F5F6;
        border-radius: 0.1rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 0.3rem;
        margin-top: 0.4rem;
    }

    .phone-model-from van-cell-group {
        width: 4rem;
    }

    .phone-model-from .van-cell {
        background: #F4F5F6;
    }

    .phone-model-inter {
        color: #BABABA;
    }

    .get-code {
        width: 88px;
        text-align: right;
    }

    .phone-model-yz {
        justify-content: space-between;
    }

    .phone-model-yz .van-cell {
        padding-left: 0;
    }

    .phone-submit-btn {
        width: 5.6rem;
        height: 0.94rem;
        background: rgba(16, 142, 233, 1);
        border-radius: 0.1rem;
        font-size: 18px;
        color: #fff;
        margin-top: 1.3rem;
    }
</style>





// WEBPACK FOOTER //
// LoginDialog.vue?9e7e828e